export const QueryKey = {
  widgetSettings: 'widget-settings',
  emailSummaries: {
    activitySummary: {
      get: 'email-summaries-activity-summary',
      patch: 'email-summaries-activity-summary-patch',
    },
  },
  conversationStarters: {
    generate: 'generate-conversation-starters',
  },
  chatPageAccess: {
    get: 'get_chat_page_access',
    patch: 'patch_chat_page_access',
  },
  inboxAutoCloseSettings: {
    get: 'get_inbox_auto_close_settings',
    patch: 'patch_inbox_auto_close_settings',
  },
  changelog: {
    list: 'changelog_list',
  },
  knowledgeBase: {
    articles: {
      listOrFilter: 'articles',
      refresh: 'refresh_article',
      refreshAll: 'refresh_all_url_articles',
      autoTag: 'auto_tag_article',
      autoTagBulk: 'auto_tag_articles_bulk',
    },
    autoRefresh: 'kb_auto_refresh',
    autoRefreshUpdate: 'kb_auto_refresh_update',
    article: 'article',
    articlesInfinite: 'knowledge-base-articles',
    articleDelete: 'article-delete',
    articlesWebsite: 'articles-website',
    articlesPdf: 'articles-pdf',
    tags: 'knowledge_base_tags',
    tagsSearch: 'knowledge_base_tags_search',
    import: {
      youtubeVideo: 'import_youtube_video',
      scrape: {
        single: 'single_url',
        multiple: 'multiple_urls',
      },
    },
    siteMapPreview: {
      get: 'site_map_preview',
      start: 'site_map_preview_start',
      selection: 'site_map_preview_selection',
      scrape: 'site_map_preview_scrape',
      children: 'site_map_preview_children',
      delete: 'site_map_preview_delete',
    },
    intercom: {
      import: 'import_intercom_articles',
      refresh: 'refresh_intercom_articles',
      delete: 'delete_intercom_articles',
    },
  },
  campaign: {
    list: 'campaigns_list',
    get: 'campaign_get',
    update: 'campaign_update',
  },
  actions: {
    basic: {
      patch: 'patch_basic_ai_action',
      delete: 'delete_ai_action',
      list: 'list_ai_actions',
      stats: 'get_ai_action_stats',
      calls: 'get_ai_action_calls',
      observed_metadata_keys: 'get_observed_metadata_keys',
    },
    httpRequest: {
      create: 'create_http_request_ai_action',
      get: 'get_http_request_ai_action',
      update: 'update_http_request_ai_action',
      test: 'test_http_request_ai_action',
      from_text: 'create_http_request_ai_action_from_text',
    },
    shopifyMcp: {
      create: 'create_shopify_remote_mcp_ai_action',
      get: 'get_shopify_mcp_ai_action',
      update: 'update_shopify_mcp_ai_action',
      test: 'test_shopify_mcp_ai_action',
    },
    knowledgeBase: {
      create: 'create_knowledge_base_mcp_ai_action',
      get: 'get_knowledge_base_ai_action',
      update: 'update_knowledge_base_ai_action',
      test: 'test_knowledge_base_ai_action',
    },
    remoteMcp: {
      create: 'create_remote_mcp_ai_action',
      get: 'get_remote_mcp_ai_action',
      update: 'update_remote_mcp_ai_action',
      connect: 'test_remote_mcp_ai_action',
    },
  },
  remoteMcp: {
    create: 'create_remote_mcp',
    get: 'get_remote_mcp',
    patch: 'patch_remote_mcp',
  },
  handoff: {
    get: 'get_handoff',
    put: 'put_handoff',
  },
  shopify: {
    editorLink: 'shopify_editor_link',
  },
  mcp: {
    get: 'get_mcp_settings',
    patch: 'patch_mcp_settings',
  },
  inboxStatus: {
    general: 'get_inbox_status',
    my: 'get_my_inbox_status',
  },
  export: {
    conversations: 'export/conversations',
    dataGathering: 'export/data_gathering',
    linkTracking: 'export/link_tracking',
    triageData: 'export/triage_data',
  },
  analytics: {
    general: 'get_dashboard_analytics',
    conversationRating: 'get_conversation_rating_analytics',
    linkTracking: 'get_link_tracking_analytics',
    userIntentDistribution: 'get_user_intent_distribution',
    unifiedInsightsList: 'get_unified_insights_list',
    setInsightReviewed: 'set_insight_reviewed',
    markAllInsightsReviewed: 'mark_all_insights_reviewed',
    unreadInsightsCount: 'get_unread_insights_count',
    sourceUrls: 'get_source_urls',
    externalCsat: 'get_external_csat_analytics',
    ttfr: 'get_ttfr_analytics',
  },
  conversationRatingConfiguration: {
    get: 'get_conversation_rating_configuration',
    patch: 'patch_conversation_rating_configuration',
  },
  aiAssistants: {
    get: 'get_ai_assistants',
    patch: 'patch_scenario_id',
  },
  aiModel: {
    get: 'get_ai_model',
    patch: 'patch_ai_model',
  },
  implementation: {
    delete: 'delete_implementation',
  },
  subscription: {
    usage: 'get_message_usage',
  },
  integration: {
    publicUrl: 'patch_public_url',
    // Generic per-integration GET/PATCH keys used by all channel-integration
    // sheets. The query key tuple is `[QueryKey.integration.get, name]` so each
    // integration (discord, telegram, ...) gets its own cache slot.
    get: 'get_integration',
    patch: 'patch_integration',
    autoCloseMinutes: 'get_integration_auto_close_minutes',
    autoCloseMinutesPatch: 'patch_integration_auto_close_minutes',
    hubspotTokenStatus: 'get_hubspot_token_status',
    hubspotPipelines: 'get_hubspot_pipelines',
    hubspotPipelinesPatch: 'patch_hubspot_pipelines',
    hubspotWhatsappTemplate: 'get_hubspot_whatsapp_template',
    hubspotWhatsappTemplatePatch: 'patch_hubspot_whatsapp_template',
    hubspotOauthMutation: 'post_hubspot_oauth_url',
    intercomValidateToken: 'post_intercom_validate_token',
    intercomRemove: 'delete_intercom_integration',
    facebookMessengerDelete: 'delete_facebook_messenger',
    slackV2Oauth: 'get_slackv2_oauth_url',
    slackV2Revoke: 'post_slackv2_revoke',
    zendeskGet: 'get_zendesk_integration',
    zendeskCreate: 'post_zendesk_integration',
    zendeskPatch: 'patch_zendesk_integration',
    zendeskDelete: 'delete_zendesk_integration',
  },
  apiTokens: {
    list: 'apiTokensList',
    create: 'createApiToken',
    revoke: 'revokeApiToken',
    updateScopes: 'updateApiTokenScopes',
    legacyInfo: 'apiLegacyTokenInfo',
  },
  onboarding: {
    progress: 'onboarding_progress',
    skip: 'onboarding_skip',
    trackPageVisit: 'onboarding_track_page_visit',
    fromUrl: 'onboarding_from_url',
  },
  gettingStarted: {
    progress: 'getting_started_progress',
    discount: 'getting_started_progress_discount',
  },
  conversationSources: 'conversation_sources',
  conversation: {
    sendMedia: 'conversation_send_media',
    createMessageFeedback: 'conversation_create_message_feedback',
    updateMessageFeedback: 'conversation_update_message_feedback',
    deleteMessageFeedback: 'conversation_delete_message_feedback',
  },
  whatsappPhoneNumbers: {
    list: 'whatsapp_phone_numbers_list',
    toggle: 'whatsapp_phone_numbers_toggle',
    test: 'whatsapp_phone_numbers_test', // Pre-built for upcoming test-message UI
    delete: 'whatsapp_phone_numbers_delete',
    status: 'whatsapp_phone_numbers_status',
    // Client-only cache key (no queryFn): tracks the optimistic "setup in
    // progress" window opened by a Step 1/Step 2 callback so the sheet can
    // render the in-progress banner and disable both setup buttons until
    // the status query confirms 'connected'. Survives sheet close/reopen
    // during the ~20s Meta-call window.
    setupInProgress: 'whatsapp_phone_numbers_setup_in_progress',
    // Client-only cache key (no queryFn): timestamp of the most recent Step
    // 1 button click, persisted to localStorage so the sheet shows Step 1
    // as done across page refresh regardless of whether FB.login returned
    // authResponse. Cleared on status='connected' or disconnect.
    step1Attempted: 'whatsapp_phone_numbers_step1_attempted',
  },
  app: {
    bootstrap: 'app_bootstrap',
    refreshJWT: 'app_refresh_jwt',
  },
  whatsappTemplates: {
    list: 'whatsapp_templates_list',
    send: 'whatsapp_templates_send',
    sendBulk: 'whatsapp_templates_send_bulk',
    validatePhones: 'whatsapp_templates_validate_phones',
  },
  simulation: {
    datasets: 'simulation_datasets',
    datasetDetail: 'simulation_dataset_detail',
    runs: 'simulation_runs',
    runDetail: 'simulation_run_detail',
    defaultEvaluationCriteria: 'simulation_default_evaluation_criteria',
    recentVisitorMessages: 'simulation_recent_visitor_messages',
    createDataset: 'simulation_create_dataset',
    updateDataset: 'simulation_update_dataset',
    deleteDataset: 'simulation_delete_dataset',
    addMessages: 'simulation_add_messages',
    uploadCsv: 'simulation_upload_csv',
    startRun: 'simulation_start_run',
    cancelRun: 'simulation_cancel_run',
  },
};
